import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p>&copy; {currentYear} Concrete World Industries</p>
    </footer>
  );
}

export default Footer;
